import Manager from './manager';

const manager = new Manager();

window.addEventListener("load", function (e) {
    manager.init("landing");
});

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */


window.addEventListener("scroll", function (e) {
    let _y = window.pageYOffset || document.documentElement.scrollTop;
    if(manager) manager.scroll.update(_y,"");
});

window.addEventListener("mousemove",function (e) {

    let _x = e.clientX;
    let _y = e.clientY;

    if(manager) if(manager.mouse) manager.mouse.update(_x,_y);

});

let MOUSE_WHEEL_EVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';

document.addEventListener(MOUSE_WHEEL_EVENT,function(e){

    if(manager) manager.wheel(e);

});


window.addEventListener("resize",function (e) {
    // executionType = "resize";


    if(manager){

        if(manager.param.displayType=="sp"&&manager.w == window.innerWidth) return;
        manager.resize();
    }
});

Pace.on("done",()=>{
   manager.status.paceDone = true;
   setTimeout(()=>{
       document.getElementsByTagName("html")[0].classList.add("is-loaded");
       document.body.classList.add("is-pace_done");
   },5e2);
});

if(Useragnt.mobile||Useragnt.tablet){
    window.addEventListener("touchstart",function (e) {
        if(manager) manager.touchStart(e);
    });
    window.addEventListener("touchmove",function (e) {

        if(manager) manager.touchmove(e);

    }, { passive: false });
    window.addEventListener("touchend",function (e) {
        if(manager) manager.touchEnd(e);
    });
    window.addEventListener("orientationchange",function (e) {
        // executionType = "onorientationchange";
        // if(manager) manager.resize();
        if(manager) manager.orientation();
    });
    window.addEventListener("deviceorientation",(e)=>{
        // X軸
        const beta = e.beta;
        // Y軸
        const gamma = e.gamma;
        // Z軸
        const alpha = e.alpha;


        // console.log(beta,gamma,alpha)

    });
}


/* ---------------------------------------------------

  -- 非同期遷移

 --------------------------------------------------- */

// Barba.Pjax.start();
// Barba.Prefetch.init();
//
// var PageTransition = Barba.BaseTransition.extend({
//     start: function() {
//         Promise
//             .all([this.newContainerLoading])
//             .then(this.out.bind(this))
//             .then(this.show.bind(this));
//     },
//     out: function() {
//         return manager.out();
//     },
//     show: function() {
//
//
//         this.newContainer.style.opacity = 0;
//
//         setTimeout(()=>{
//             document.body.id = manager.status.pageID;
//
//             if(manager.status.pageID!=='top'){
//                 document.body.classList.add("lowlayer");
//             }
//
//             this.oldContainer.style.display = "none";
//             setTimeout(()=>{
//                 manager.init("trans");
//             },6e2);
//         },1e3);
//         setTimeout(()=>{
//             this.newContainer.style.opacity = 1;
//             manager.show();
//             manager.resize();
//             this.done();
//         },17e2);
//
//     }
// });
//
// Barba.Dispatcher.on('newPageReady', function(currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {
//
//     /* ページ情報取得 */
//     // _pageID = currentStatus.namespace;
//
//     manager.status.pageID = currentStatus.namespace;
//
//
//     /* head内書き換え */
//     var head = document.head;
//     var newPageRawHead = newPageRawHTML.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0];
//     var newPageHead = document.createElement('head');
//     newPageHead.innerHTML = newPageRawHead;
//
//     var removeHeadTags = [
//         "meta[name='keywords']"
//         ,"meta[name='description']"
//         ,"meta[property^='og']"
//         ,"meta[name^='twitter']"
//         ,"meta[itemprop]"
//         ,"link[itemprop]"
//         ,"link[rel='prev']"
//         ,"link[rel='next']"
//         ,"link[rel='canonical']"
//     ].join(',');
//
//     var headTags = head.querySelectorAll(removeHeadTags)
//     for(var i = 0; i < headTags.length; i++ ){
//         head.removeChild(headTags[i]);
//     }
//     var newHeadTags = newPageHead.querySelectorAll(removeHeadTags)
//
//     for(var i = 0; i < newHeadTags.length; i++ ){
//         head.appendChild(newHeadTags[i]);
//     }
//     document.body.classList = "";
//     document.body.classList.add("is-asy");
//     manager.scroll.loadUpdate();
//
//     //アナリティクスに送信
//     //ga('send', 'pageview', window.location.pathname.replace(/^\/?/, '/') + window.location.search);
//
//     /* html書き換え */
//
// });
//
// Barba.Pjax.getTransition = function() {
//     return PageTransition;
// };
// Barba.Dispatcher.on("load", function() {
// });
//
// //遷移前の処理
// Barba.Pjax.originalPreventCheck = Barba.Pjax.preventCheck;
// Barba.Pjax.preventCheck = function(evt, element) {
//     return Barba.Pjax.originalPreventCheck(evt, element)
//
//
//     if(element){
//         if(element.getAttribute("target") === '_blank') return false;
//         return Barba.Pjax.originalPreventCheck(evt, element)
//     }else{
//         return Barba.Pjax.originalPreventCheck(evt, element)
//         // return true;
//     }
//     if(element) {
//         if(element.classList.contains('no-barba')){
//             return false;
//         }
//     }
// };
//
// Barba.Dispatcher.on('linkClicked', (element, event) => {
//
//     //if(!scroll.status.comp) return; //スクロール中は通さない
//
//     // _successURL = element.getAttribute('href');
//
// });
